(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-variant-carousel"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function() {
    $('.carousel').flickity({
      cellAlign: 'left',
      contain: true,
      pageDots: false,
      prevNextButtons: true,
      autoPlay: false,
      freeScroll: true,
      draggable: false,
    });
  });

  } catch(e) { console.error(e); }
})();
})();
